// Card.js
import React from 'react';
import OurServicesStyles from '../../styles/OurServicesStyles/OurServicesCard.module.css'; // CSS Module import

const OurServicesCard = ({ data,right=false }) => {
    return (
      <div className={OurServicesStyles.card} style={{flexWrap:right ? 'wrap':'wrap-reverse'}}>
        {!right&&
          <div className={OurServicesStyles.imageWrapper}>
            <img src={data?.image} alt={data?.title} className={OurServicesStyles.cardImageTopRight} />
          </div>
        }
        <div className={OurServicesStyles.content}>
            <h3>{data?.title}</h3>
            <p>{data?.description}</p>
            <div className={OurServicesStyles.focus}>
                {data?.focus?.map((item, index) => (
                <div key={index} className={OurServicesStyles.focusItem}>
                    <span className={OurServicesStyles.icon}>{item.icon}</span>
                    <span className={OurServicesStyles.title}>{item.title}</span>
                </div>
                ))}
            </div>
        </div>
        {right&&
          <div className={OurServicesStyles.imageWrapper}>
            <img src={data?.image} alt={data?.title} className={OurServicesStyles.cardImageTopLeft} />
          </div>
        }
      </div>
    );
  };

export default OurServicesCard;